// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3795q","unreadBadge":"styles_unreadBadge__WMBLx","modalContent":"styles_modalContent__2mW94","modal":"styles_modal__5-tA0"};